import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import ArticlesService from '../../services/articles.service';
import Ghost from '../../views/ghost/Ghost';
import ContentPieceDTO from '../../DTOs/ContentPieceDTO';
import SingleArticle from '../single-article/SingleArticle';
import NotFound from '../../pages/not-found/NotFound';
import { useErrorBoundary } from 'react-error-boundary';
import Variations from '../variations/Variations';
import SortVariationsHelper from '../../helpers/sort-variation.helper';
import { Statuses } from '../../enums/Statuses';
import Stories from '../../views/stories/Stories';

const Article = () => {
  const { guid } = useParams();
  const [article, setArticle] = useState<ContentPieceDTO>(
    ContentPieceDTO.getDefaultContentPiece()
  );
  const [status, setStatus] = useState<Statuses>(Statuses.IDLE);
  const { showBoundary } = useErrorBoundary();

  const validateArticle: boolean = useMemo(() => {
    return (
      Number.isInteger(Number(guid)) && Number(guid) > 0 && null !== article
    );
  }, [guid, article]);

  useEffect(() => {
    if (!guid || !validateArticle) {
      return;
    }
    const abortController = new AbortController();
    setStatus(Statuses.PENDING);
    ArticlesService.getById(guid)
      .then((data) => {
        setArticle(data);
        setStatus(Statuses.SUCCESS)
      })
      .catch((error: Error) => {
        setStatus(Statuses.ERROR);
        showBoundary(error);
      })
      .finally(() => setStatus(Statuses.IDLE));

      return () => abortController.abort();
  }, [guid, validateArticle, showBoundary]);

  if (false === validateArticle) {
    return <NotFound />;
  }

  return (
    <Box className='container mt-5'>
      {status === Statuses.PENDING ? (
        <Box className='boxed'>
          <Ghost className='article' />
        </Box>
      ) : (
        <Box className='d-flex flex-column gap-4'>
          <SingleArticle article={article} />
          {article.getStories().length === 0 ?
            <Variations variations={SortVariationsHelper.sortVariationsById(article?.getVariationContentPieces())} /> :
            <Stories stories={article.getStories()} />}
        </Box>
      )}
    </Box>
  );
};

export default Article;
